import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-confirm-service-cancel',
  imports: [MatDialogModule],
  templateUrl: './modal-confirm-service-cancel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-confirm-service-cancel.component.scss',
})
export class ModalConfirmServiceCancelComponent {

}
